import React, {useEffect, useState} from 'react';
import {constructStuffInfo, StuffInfo} from '../../../interface/model/visitorExtends';
import {BlueButton} from "../../../component/button";

export default function StuffInfoComponent({stuffInfosData, onClickHandler}) {
    const [ modal, setModal ] = useState<boolean>(false);

    return (
        <>
            <BlueButton type={'button'}
                          innerHTML={stuffInfosData!==undefined ? '수정' : '등록'}
                          onClickHandler={() => setModal(true)}
            />
            {
                modal &&
                    <Modal
                        stuffInfosData={stuffInfosData}
                        submitHandler={onClickHandler}
                        closeModal={setModal} />
            }
        </>
    )
}

interface localStuffInfo {
    stuffInfo:StuffInfo
}

function Modal({stuffInfosData, submitHandler, closeModal}) {

    const [ stuffInfo, setStuffInfo ] = useState<Array<localStuffInfo>>([]);

    function submit(e) {
        e.preventDefault();
        submitHandler(stuffInfo.map(row => row.stuffInfo));
        closeModal(false);
    }

    function addVisitorStuffInfoHandler() {
        setStuffInfo(stuffInfo.concat([{stuffInfo:{...constructStuffInfo, category : '노트북'}}]));
    }

    function removeVisitorStuffInfoHandler(tmpKey) {
        setStuffInfo(stuffInfo.filter((r, index) => tmpKey !== index));
    }

    function onChangeHandler(tmpKey, e) {
        setStuffInfo(stuffInfo.map((row, index) => {
                return tmpKey === index
                    ? {...row, stuffInfo : {...row.stuffInfo, [e.target.name] : e.target.value} }
                    : {...row}
            }
        ));
    }

    useEffect(() => {
        if(stuffInfosData!==undefined) {
            let arr = new Array();
            stuffInfosData.map((row, index) => (
                arr.push({tmpKey:index, stuffInfo:row})
            ))
            if(arr.length!==0)
                setStuffInfo(arr)
        } else {
            setStuffInfo([{stuffInfo:{...constructStuffInfo, category : '노트북'}}]);
        }
    }, [])

    return (
        <div className="modal nv_modal1 on">
            <div className="nv_modal_container" style={{maxWidth: 'none', width: '70%'}}>
                <div className="nv_modal_header">
                    <h2 id="find-host-title">방문자 반입물품</h2>
                    <p className="nv_modal_close" onClick={() => closeModal(false)}>닫기</p>
                </div>
                <form onSubmit={submit}>
                    <div className="nv_modal_contents" style={{padding: '5px 15px'}}>
                        <table className="nv_table">
                            <thead id="visitorThead">
                            <tr>
                                <th scope="row">구분</th>
                                <th scope="row">시리얼번호</th>
                                <th scope="row">사용목적</th>
                                <th scope="row">비고</th>
                                <th scope="row">삭제</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                stuffInfo.map((row, index) => (
                                    <tr key={`stuffInfoKey-${index}`}>
                                        <td style={{maxWidth: '180px'}}>
                                            <select name="category" className="nv_select_box"
                                                    onChange={(e) => onChangeHandler(index, e)}
                                            >
                                                <option selected={row.stuffInfo.category === '노트북'} value={"노트북"}>노트북
                                                </option>
                                                <option selected={row.stuffInfo.category === 'PC'} value={"PC"}>PC
                                                </option>
                                                <option selected={row.stuffInfo.category === '저장장치(USB,외장하드)'}
                                                        value={"저장장치(USB,외장하드)"}>저장장치(USB,외장하드)
                                                </option>
                                                <option selected={row.stuffInfo.category === '기타'} value={"기타"}>기타
                                                </option>
                                            </select>
                                            {
                                                row.stuffInfo.category === "기타" ?
                                                    <input type='text'
                                                           className="nv_category_etc"
                                                           name='category_etc'
                                                           placeholder="상세내용"
                                                           onChange={(e) => onChangeHandler(index, e)}
                                                    /> : ''
                                            }
                                        </td>
                                        <td>
                                            <input type='text'
                                                   className="nv_input"
                                                   name='serialNo'
                                                   placeholder="시리얼번호"
                                                   value={row.stuffInfo.serialNo}
                                                   required={true}
                                                   onChange={(e) => onChangeHandler(index, e)}
                                            />
                                        </td>
                                        <td>
                                            <input type='text'
                                                   className="nv_input"
                                                   name='purpose'
                                                   placeholder="사용목적"
                                                   value={row.stuffInfo.purpose}
                                                   required={true}
                                                   onChange={(e) => onChangeHandler(index, e)}
                                            />
                                        </td>
                                        <td>
                                            <input type='text'
                                                   className="nv_input"
                                                   name='notice'
                                                   placeholder="비고"
                                                   value={row.stuffInfo.notice}
                                                   onChange={(e) => onChangeHandler(index, e)}
                                            />
                                        </td>
                                        <td style={{textAlign: 'center'}}>
                                            {
                                                index !== 0 &&
                                                <button type="button"
                                                        className="nv_button_red minus"
                                                        onClick={() => removeVisitorStuffInfoHandler(index)}>삭제</button>
                                            }
                                        </td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>
                        <div className="nv_btn_area" style={{margin: '10px 0 0 0'}}>
                            <button type="button"
                                    className="nv_btn_blue add"
                                    onClick={addVisitorStuffInfoHandler}
                            >
                                반입물품 추가
                            </button>
                        </div>
                    </div>
                    <div className="nv_btn_area" style={{textAlign: 'center', margin: '10px 0px'}}>
                        <button type="submit" className="nv_btn_blue">저장</button>
                    </div>
                </form>
            </div>
        </div>
    )
}